import { Component, OnInit } from '@angular/core';
import { RetornoSelecao } from './../../shared/gridview/RetornoSelecao';
import { Estado } from './../../shared/shared/estado.enum';
import { UsuarioFabricaService } from './usuario-fabrica-service/usuario-fabrica.service';
import { CrudBase } from './../../../../src/app/shared/crud/CrudBase';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-usuario-fabrica',
  templateUrl: './usuario-fabrica.component.html',
  styleUrls: ['./usuario-fabrica.component.css']
})
export class UsuarioFabricaComponent
  implements OnInit {

  selecionado: object;
  state: Estado = Estado.view;

  filtros = {};

  constructor(private service: UsuarioFabricaService) { }

  ngOnInit() {
  }

  buscar() {
    this.selecionado = undefined;
    this.state = Estado.view;
  }

  selecionar(selecionado: RetornoSelecao) {
    if (selecionado.novoCadastro) {
      this.state = Estado.insert;
    } else {
      this.state = Estado.view;
    }
    this.selecionado = selecionado.registro;
  }

  definirFiltro(): void {
    $('#usuario-fabrica-filtro').modal();
  }

}
